import EdTreeSelect from './src/EdTreeSelect.vue'

/* istanbul ignore next */
EdTreeSelect.install = function (Vue) {
    Vue.component(EdTreeSelect.name, EdTreeSelect)
}

export default EdTreeSelect
